import  * as React from 'react'
// Translation
import {useI18next} from 'gatsby-plugin-react-i18next'
import { graphql } from 'gatsby';
//components
import Layout from '../../components/layout/layout'
import { Seo } from '../../components/seo';
import BoxInfo from '../../components/boxinfo';

const Produktentwicklung = () => {
    const {t} = useI18next();
    return (
       <Layout pageTitle={t('title')} subTitle={t('subtitle')}>
          {/* Block mit weissem hintergrund 
        */}
          <div className='row'>
            {/* 1 oder mehr Blöcke am Anfang: Titel und Text / ggf später ein Bild */}
            <div className='col-12'>
              <div className='container'>
            {/* 1: Überschrift */}
                <h1 align="center"> {t('title1')} </h1>
                <p> {t('text1')} </p>
                
                <h1 align="center"> {t('title2')} </h1>
                <p> {t('text2')} </p>              
                {/*<p>{t('bildtext1')}</p>              : ggf ein Bild einfügen / passt hier aber nicht
                <StaticImage alt="ein bild" src="../images/CAD-Zeichnungen-RK.jpg"/> */}
              </div>
            </div>
          </div>
        </Layout>


    );
};

export default Produktentwicklung

// Fuer Search engine optimizationjj
export const Head = () =>( <Seo title="Produktentwicklung" keywords="Produktentwicklung Biopolymere" /> )

// Für Mehrsprachigkeit, graphql muss am anfang import werden!
export const query = graphql`
query ($language: String!) {
  locales: allLocale(
    filter: { ns: { in: ["produktentwicklung"] }, language: { eq: $language } }
  ) {
    edges {
      node {
        ns
        data
        language
      }
    }
  }
}
`;